var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.601,
    height: 22.006,
    viewBox: "0 0 34.601 22.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3554",
    "data-name": "Group 3554",
    transform: "translate(-1509.122 -7977.483)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6124",
    "data-name": "Line 6124",
    y2: 32.601,
    transform: "translate(1510.122 7988.487) rotate(-90)",
    fill: "none",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4558",
    "data-name": "Path 4558",
    d: "M0,0,9.589,9.587,19.178,0",
    transform: "translate(1533.135 7998.075) rotate(-90)",
    fill: "none",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackArrow);
export default __webpack_public_path__ + "static/media/black-arrow.d242e765a0e1f8aaa6d4735c5beed7ea.svg";
export { ForwardRef as ReactComponent };